import { useEffect } from "react";
import * as Sentry from "@Sentry";
import { useSelector } from "react-redux";
import { useAppDispatch as useDispatch } from "@Reducers/hooks";
import { Badge } from "@mui/material";
import { useTranslation } from "@i18n";
import IconComponent from "@CubeComponents/icons";
import { RootState } from "@Reducers/index";
import { setShowPortalChat, setPortalChatUnreadCount } from "../../../reducers/portalChat";
import { getUnreadSummaryRequest } from "../api/portalChat.api";

/** Header Chats icon with the unread-conversation badge (muted excluded, 99+ cap). */
function PortalChatIcon() {
  const { t } = useTranslation();
  const showPortalChat = useSelector((state: RootState) => state.showPortalChat);
  const unreadCount = useSelector((state: RootState) => state.portalChatUnreadCount);
  const dispatch = useDispatch();

  useEffect(() => {
    let cancelled = false;
    getUnreadSummaryRequest()
      .then((response) => {
        if (!cancelled && response.data.status) {
          dispatch(setPortalChatUnreadCount(response.data.unreadConversations ?? 0));
        }
      })
      .catch((error: unknown) => {
        // The badge is best-effort; the panel refreshes the count when opened.
        Sentry.captureException(error);
      });
    return () => {
      cancelled = true;
    };
  }, [dispatch]);

  return (
    <div data-testid="portalChatIcon" className="flex relative">
      <Badge
        sx={{
          "& .MuiBadge-badge": {
            color: "white",
            backgroundColor: "#6BBBE3",
          },
        }}
        badgeContent={unreadCount > 99 ? "99+" : unreadCount}
        max={99}
      >
        <IconComponent
          onClick={() => dispatch(setShowPortalChat(!showPortalChat))}
          position="bottom"
          toolTipContent={t("Chats")}
          name="Chat"
          width="1.5rem"
          height="1.5rem"
        />
      </Badge>
    </div>
  );
}

export default PortalChatIcon;
